/* import __COLOCATED_TEMPLATE__ from './chart-horizontal-bar.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();